import { UpdateSundvaegtProgram } from '@/shared/interfaces/api/sundvaegt-interfaces';
import { fetchIStatus } from '@/shared/fetchIStatus';

export const updateSundVaegtProgram = async (
    updateSundVaegtProgram: UpdateSundvaegtProgram,
): Promise<null> => {
    return await fetchIStatus<null, UpdateSundvaegtProgram>(
        '/api/sundvaegt/program',
        'PATCH',
        updateSundVaegtProgram,
    );
};
